import { ObjectStore } from '@softline/core';

export const AuthenticationContextStore = ObjectStore.create();
